import { CSSProperties } from "react";
import { tokens } from 'src/design-system';
import { commonStyleSheet } from "src/Library/CommonStyles";

const styles = (theme: any) => ({
  ...commonStyleSheet,
  parent: {
    ...commonStyleSheet.flexColumn,
    width: '96%',
    padding: tokens.spacing.ms,
    height: 93,
    justifyContent: 'space-between',
    margin: `${tokens.spacing.sm}px ${tokens.spacing.md}px`,
    boxSizing: 'border-box',
    border: '1px solid #FAF8F1',
    borderRadius: tokens.radius.md,
    backgroundColor: '#FCFAF4',
  },
  cardHover: {
    '& .ant-checkbox-wrapper': {
      opacity: 0,
      transition: 'opacity 0.3s',
    },
    '&:hover': {
      '& .ant-checkbox-wrapper': {
        opacity: 1,
        transition: 'opacity 0.3s',
      },
    },
  },
  cardDataContainer: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
  },
  smallText: {
    color: '#595959',
    fontSize: tokens.fontSize.small,
    fontWeight: tokens.fontWeight.semibold,
    lineHeight: '17px',
  },
  bigText: {
    color: '#262626',
    fontSize: tokens.fontSize.body,
    fontWeight: tokens.fontWeight.semibold,
    lineHeight: '19px',
    cursor: 'default',
    marginTop: '3px',
  },
  hover: {
    cursor: 'pointer',
    '&:hover': {
      color: theme.primaryColor,
    },
  },
  success: {
    backgroundColor: '#27B479',
    borderColor: '#27B479',
    color: '#fff',
    textTransform: 'capitalize',
    marginLeft: tokens.spacing.md,
    fontSize: tokens.fontSize.caption,
    fontWeight: tokens.fontWeight.regular,
    borderRadius: '18px',
  },
  error: {
    backgroundColor: `${theme.errorColor}`,
    borderColor: `${theme.errorColor}`,
    color: '#fff',
    textTransform: 'capitalize',
    marginLeft: tokens.spacing.md,
    fontSize: tokens.fontSize.caption,
    fontWeight: tokens.fontWeight.regular,
    borderRadius: '18px',
  },
  bottomRow: {
    ...commonStyleSheet.flexRow,
    justifyContent: 'space-between',
    marginTop: 10,
  },
  delayed: {
    opacity: '100%',
    borderColor: '#F38755',
    color: '#595959',
    textTransform: 'capitalize',
    marginLeft: '0px',
    marginRight: tokens.spacing.ms,
    fontSize: tokens.fontSize.caption,
    fontWeight: tokens.fontWeight.regular,
    borderRadius: '18px',
    cursor: 'default',
  },
  archived: {
    opacity: 0.7,
    filter: 'grayscale(100)',
  },
  anchor: {
    color: theme.primaryColor,
    fontSize: tokens.fontSize.small,
    fontWeight: tokens.fontWeight.semibold,
    cursor: 'pointer',
  },
  tracking: {
    border: '1px solid',
    borderRadius: tokens.radius.md,
    padding: `0px ${tokens.spacing.sm}px`,
  },
  renderFetch: {
    fontSize: tokens.fontSize.small,
    display: 'flex',
    width: '50%',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '22px',
  },
  blStyleBold: {
    color: '#595959',
    fontSize: '11px',
    lineHeight: '11px',
    fontFamily: 'Open Sans',
    fontStyle: 'regular',
    marginTop: '5px',
    display: 'grid',
    gridTemplateColumns: 'auto auto',
    gridColumnGap: `${tokens.spacing.sm}px`,
    gridRowGap: tokens.spacing.md,
  },
  blStyle: {
    color: '#595959',
    fontSize: '11px',
    lineHeight: '11px',
    fontFamily: 'Open Sans',
    fontStyle: 'regular',
    marginTop: '5px',
    display: 'inherit',
  } as CSSProperties,
  blNumberBold: {
    color: '#262626',
    fontSize: tokens.fontSize.body,
    fontWeight: tokens.fontWeight.semibold,
  },
  blNumber: {
    color: '#595959',
    fontFamily: 'Open Sans SemiBold',
    fontSize: '11px',
    marginLeft: tokens.spacing.xs,
    fontWeight: tokens.fontWeight.semibold,
  } as CSSProperties,
  shareStyle : {
    fontSize: '17px',
    color: '#595959',
    cursor: 'pointer',
  },
  metaData: {
    color: '#595959',
    fontSize: tokens.fontSize.small,
    lineHeight: '14px',
    display: 'flex',
  },
  shippingLine: {
    width: 'auto',
    marginLeft: '2%',
    marginRight: '2%',
    maxWidth: 80,
    maxHeight: 60,
  },
  reference: {
    color: tokens.colors.primaryDark,
    fontSize: tokens.fontSize.small,
    fontWeight: 'bold',
    cursor: 'pointer',
    textDecoration: 'underline',
  },
  containerSize: {
    color: tokens.colors.text,
    fontSize: tokens.fontSize.small,
    fontWeight: tokens.fontWeight.semibold,
  },
  referenceDetails: {
    ...commonStyleSheet.flexColumn,
    width: '16%',
  },
  trackingFailed: {
    fontSize: tokens.fontSize.small,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '40px',
    color: '#EA4D4E',
    width: '50%',
  },
  leftContent: {
    ...commonStyleSheet.flexRow,
    width: '98%',
  },
  viewTrackingLink: {
    color: tokens.colors.primaryDark,
    fontSize: tokens.fontSize.caption,
    fontWeight: tokens.fontWeight.semibold,
    marginRight: tokens.spacing.sm,
    cursor: 'pointer',
  },
  updatedAt: {
    color: '#666666',
    fontSize: 8,
    fontStyle: 'italic',
    textAlign: 'right',
  },
  title: {
    fontSize: tokens.fontSize.caption,
    color: '#666666',
  },
  value: {
    color: tokens.colors.textSecondary,
    fontWeight: tokens.fontWeight.semibold,
    fontSize: tokens.fontSize.caption,
    marginLeft: tokens.spacing.sm,
    marginRight: 20,
  },
});

export default styles;
